import ancientArtillery from './ancientArtillery.png';
import banditArcher from './banditArcher.png';
import banditGuard from './banditGuard.png';
import blackImp from './blackImp.png';
import caveBear from './caveBear.png';
import cityArcher from './cityArcher.png';
import cityGuard from './cityGuard.png';
import cultist from './cultist.png';
import deepTerror from './deepTerror.png';
import earthDemon from './earthDemon.png'
import flameDemon from './flameDemon.png'
import frostDemon from './frostDemon.png'
import forestImp from './forestImp.png'
import giantViper from './giantViper.png'
import harrowerInfester from './harrowerInfester.png'
import hound from './hound.png'
import inoxArcher from './inoxArcher.png'
import inoxGuard from './inoxGuard.png'
import inoxShaman from './inoxShaman.png'
import livingBones from './livingBones.png'
import livingCorpse from './livingCorpse.png'
import livingSpirit from './livingSpirit.png'
import lurker from './lurker.png'
import nightDemon from './nightDemon.png'
import ooze from './ooze.png'
import rendingDrake from './rendingDrake.png'
import savvasLavaflow from './savvasLavaflow.png'
import savvasIcestorm from './savvasIcestorm.png'
import spittingDrake from './spittingDrake.png'
import stoneGolem from './stoneGolem.png'
import sunDemon from './sunDemon.png'
import vermlingScout from './vermlingScout.png'
import vermlingShaman from './vermlingShaman.png'
import windDemon from './windDemon.png'

import banditCommander from './bosses/banditCommander.jpg';
import captainOfTheGuard from './bosses/captainOfTheGuard.jpg';
import darkRider from './bosses/darkRider.jpg';
import elderDrake from './bosses/elderDrake.jpg';
import inoxBodyguard from './bosses/inoxBodyguard.jpg';
import jekserah from './bosses/jekserah.jpg';
import mercilessOverseer from './bosses/mercilessOverseer.jpg';
import primeDemon from './bosses/primeDemon.jpg';
import sightlessEye from './bosses/sightlessEye.jpg';
import theBetrayer from './bosses/theBetrayer.jpg';
import theColorless from './bosses/theColorless.jpg';
import theGloom from './bosses/theGloom.jpg';
import wingedHorror from './bosses/wingedHorror.jpg';




const monsterImagesList = {
  "Ancient Artillery":ancientArtillery, 
  "Bandit Archer":banditArcher, 
  "Bandit Guard":banditGuard, 
  "Black Imp":blackImp, 
  "Cave Bear":caveBear, 
  "City Archer":cityArcher, 
  "City Guard":cityGuard, 
  "Cultist":cultist, 
  "Deep Terror":deepTerror, 
  "Earth Demon":earthDemon, 
  "Flame Demon":flameDemon, 
  "Frost Demon":frostDemon, 
  "Forest Imp":forestImp, 
  "Giant Viper":giantViper, 
  "Harrower Infester":harrowerInfester, 
  "Hound":hound, 
  "Inox Archer":inoxArcher, 
  "Inox Guard":inoxGuard, 
  "Inox Shaman":inoxShaman, 
  "Living Bones":livingBones, 
  "Living Corpse":livingCorpse, 
  "Living Spirit":livingSpirit, 
  "Lurker":lurker, 
  "Night Demon":nightDemon, 
  "Ooze":ooze, 
  "Rending Drake":rendingDrake, 
  "Savvas Lavaflow":savvasLavaflow, 
  "Savvas Icestorm":savvasIcestorm, 
  "Spitting Drake":spittingDrake, 
  "Stone Golem":stoneGolem, 
  "Sun Demon":sunDemon, 
  "Vermling Scout":vermlingScout, 
  "Vermling Shaman":vermlingShaman, 
  "Wind Demon":windDemon,

  "Bandit Commander":banditCommander,
  "Captain of the Guard":captainOfTheGuard,
  "Dark Rider":darkRider,
  "Elder Drake":elderDrake,
  "Inox Bodyguard":inoxBodyguard,
  "Jekserah":jekserah,
  "Merciless Overseer":mercilessOverseer,
  "Prime Demon":primeDemon,
  "The Sightless Eye":sightlessEye,
  "The Betrayer":theBetrayer,
  "The Colorless":theColorless,
  "The Gloom":theGloom,
  "Winged Horror":wingedHorror
}

export default monsterImagesList;


// WEBPACK FOOTER //
// ./src/lib/monsterImages/monsterImagesList.js